export default __webpack_public_path__ + "static/media/promo_02.4c0cd68d.jpg";